<ion-item *ngFor="let item of xmlTopics">
  <ion-icon name="information-circle-sharp" slot="start" size="large"></ion-icon>
  <ion-label class="ion-text-wrap">
    <h2><strong [translate]="item.name"></strong></h2>
    <h2 *ngIf="!isCheckbox(item)" [translate]="item.value"></h2>
  </ion-label>
  <ion-checkbox *ngIf="isCheckbox(item)" disabled="true" checked="{{ item.value === '1' }}" slot="end"></ion-checkbox>
</ion-item>
